import React, { PropTypes, Component } from 'react'
import { DatePicker } from 'react-date-picker'
import 'react-date-picker/index.css'
import styled from 'styled-components'
import { Colors, Fonts, Metrics } from '../../Themes'

const CalendarContainer = styled.div`
  position: relative;
  .calendarTitle {
    margin-bottom: ${Metrics.margins.small};
    ${Fonts.style.Label};
    color: ${Colors.black};
  }
`

const PlaceholderContainer = styled.div`
  border: ${Metrics.borders.default}
  border-radius: ${Metrics.borders.defaultRadius};
  padding: 8px;
  min-height: 30px;
  cursor: pointer;
`

const Date = styled.div`
  ${Fonts.style.Input};
  color: ${Colors.black};
`

const Placeholder = styled.div`
  outline: none;
  ${Fonts.style.Input};
`

const Error = styled.div`
  margin-top: ${Metrics.margins.tiny};
  ${Fonts.style.Input};
  color: ${Colors.red};
`

const DatePickerContainer = styled.div`
  position: absolute;
  .react-date-picker__calendar--theme-default{
    background: ${Colors.white};
    border: ${Metrics.borders.default};
    box-shadow: ${Metrics.shadows.defaultShadow};
    border-radius: ${Metrics.borders.defaultRadius};
    ${Fonts.style.Input};
    margin-top: ${Metrics.margins.small};
    padding: ${Metrics.margins.small};

    .react-date-picker__nav-bar-date  {
      ${Fonts.style.Input};
      color: ${Colors.black}
      pointer-events: none;
    }

    .react-date-picker__nav-bar-secondary-arrow {
      display: none !important;
    }

    .react-date-picker__nav-bar-arrow {
      margin-right: ${Metrics.margins.base};
      margin-left: ${Metrics.margins.base};
    }

    .react-date-picker__month-view-day--weekend-highlight, .react-date-picker__month-view-day--today-highlight {
      ${Fonts.style.Input};
      color: ${Colors.black}
    }

    .react-date-picker__month-view-day-text{
      &:hover{
        background: ${Colors.primary} !important;
        color: ${Colors.white};
      }
    }
    .react-date-picker__month-view-day--next-month, .react-date-picker__month-view-day--prev-month{
      ${Fonts.style.Input};
      color: ${Colors.lightGrey};
    }
  }
`

const Title = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Label};
  color: ${Colors.black};
`

class Calendar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.handleSelect = this.handleSelect.bind(this)
    this.toggleDatePicker = this.toggleDatePicker.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  handleSelect (value) {
    this.setState({ open: false }, () => this.props.handleSelect(value))
  }

  toggleDatePicker (event) {
    this.setState({ open: !this.state.open })
  }

  handleBlur () {
    setTimeout(() => {
      if (this.props.handleBlur) {
        this.props.handleBlur()
      }
      this.setState({
        open: false
      })
    }, 250)
  }

  render () {
    const { title, value, error } = this.props
    return (
      <CalendarContainer
        {...this.props}
        tabIndex={'-1'}
        onBlur={this.handleBlur}>
        <Title>{title}</Title>
        <PlaceholderContainer onClick={this.toggleDatePicker}>
          <Placeholder>
            {value ? <Date>{value}</Date> : 'Select a Date'}
          </Placeholder>
        </PlaceholderContainer>
        {this.state.open && (
          <DatePickerContainer>
            <DatePicker
              navigation
              locale={'en'}
              forceValidDate
              highlightWeekends={false}
              highlightToday={false}
              weekNumbers={false}
              weekStartDay={0}
              footer={false}
              weekDayNames={false}
              style={Fonts.style.Text}
              dateFormat={'DD/MM/YYYY'}
              onChange={(dateString, { dateMoment, timestamp }) =>
                this.handleSelect(dateString)}
            />
          </DatePickerContainer>
        )}
        {error && <Error className={'error'}>{error}</Error>}
      </CalendarContainer>
    )
  }
}

Calendar.propTypes = {
  title: PropTypes.string,
  handleSelect: PropTypes.func,
  handleBlur: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string
}

export default Calendar



// WEBPACK FOOTER //
// ./src/components/Calendar/index.js